import 'generated/initializer'
